
import styled, { css } from 'styled-components';

const PoweredText = () => css`
    position: absolute;
    font-family: SharpSansBold;
    font-size:12px;
    top:90%;
    color:white;
    text-align: center;
`;


export default styled.div([PoweredText]);